import React from 'react'
import { TableRow, TableCell, Menu, MenuItem } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import dayjs from 'dayjs'
import { USER_POLICY_STATUS } from '../../../models/user-models/UserStatus'

export const RecentSubmissionTableRow = ({ quote, onQuoteClick, options }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  let quoteUrl = undefined
  if (quote && quote.latestQuote && quote.latestQuote.quote_document_url) {
    quoteUrl = quote.latestQuote.quote_document_url
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = choice => {
    setAnchorEl(null)
  }

  const handleOpenQuoteFlow = () => {
    handleClose()
    onQuoteClick(quote)
  }

  const onMenuItemClick = option => {
    handleClose()
    option.onClick()
  }

  return (
    <TableRow onClick={handleOpenQuoteFlow} className="clickable" key={quote.id}>
      <TableCell component="th" scope="row">
        {quote.firstName} {quote.lastName}
      </TableCell>
      <TableCell>{quote.email}</TableCell>
      <TableCell>{dayjs(quote.activityDate).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT))}</TableCell>
      <TableCell>{quote.status}</TableCell>
      <TableCell onClick={e => e.stopPropagation()}>
        <IconButton onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
          {options.map(option => (
            <MenuItem
              disabled={
                (quote.status === USER_POLICY_STATUS.QUOTED || quote.status === USER_POLICY_STATUS.CREATED) &&
                option.text === 'Manage Policies'
              }
              key={option.text}
              onClick={() => onMenuItemClick(option)}
            >
              {option.text}
            </MenuItem>
          ))}
        </Menu>
      </TableCell>
    </TableRow>
  )
}
